/**
 * NikahElegant — design tokens.
 *
 * Emerald green, gold, and ivory palette for an elegant Muslim Nikah ceremony.
 */

import type { CSSProperties } from 'react';

export interface NikahTheme {
  emerald: string;
  emeraldDark: string;
  gold: string;
  goldSoft: string;
  ivory: string;
  ivoryDark: string;
  ink: string;
  muted: string;
  border: string;
}

export const nikahTheme: NikahTheme = {
  emerald: '#0f6b4f',
  emeraldDark: '#073d2c',
  gold: '#c9a227',
  goldSoft: '#f0e0a0',
  ivory: '#fbfdfb',
  ivoryDark: '#eef5f0',
  ink: '#0a1f17',
  muted: '#5e7a6e',
  border: 'rgba(15,107,79,0.12)',
};

export const NIKAN_EASE = [0.22, 1, 0.36, 1] as const;

export function themeCssVars(theme: NikahTheme): CSSProperties {
  return {
    '--nikah-emerald': theme.emerald,
    '--nikah-emerald-dark': theme.emeraldDark,
    '--nikah-gold': theme.gold,
    '--nikah-gold-soft': theme.goldSoft,
    '--nikah-ivory': theme.ivory,
    '--nikah-ivory-dark': theme.ivoryDark,
    '--nikah-ink': theme.ink,
    '--nikah-muted': theme.muted,
    '--nikah-border': theme.border,
  } as CSSProperties;
}
